import loadScript from '../../util/loadscript';
import base64 from '../../util/base64';
import Client from '../client';
import { APPLIST, QQ_SHARE_API, WEIBO_SHARE_API } from './constant';
import Clipboard from 'clipboard';
import parseUrl from '../../util/parse-url';

export default class ShareLogic {
  static track(channelId) {
    if (window.$ACE) {
      let channel = Client.getChannel();
      window.$ACE.Tracker.record('/aliyun.share.click', 'CLK', `type=${channelId}&channel=${channel}`);
    }
  }
  static hideMask(container) {
    container.find('.share-bar-bottom-mask').removeClass('show');
  }
  static openMask(container) {
    container.find('.share-bar-bottom-mask').addClass('show');
  }
  static shareToAliyunApp() {}
  static async appShare(config) {
    ShareLogic.track('D');
    if (!window.WindVane) {
      await loadScript('//g.alicdn.com/??mtb/lib-windvane/2.1.8/windvane.js,mtb/lib-env/1.9.9/env.js');
    }
    let params = {
      title: config.title,
      content: config.content,
      url: config.url,
      imageUrl: config.img,
    };
    if (window.WindVane) {
      window.WindVane.call('Aliyun', 'share', params, function() {}, function() {});
    }
  }
  static browserShare(container, config) {
    ShareLogic.openMask(container);
    const $shareList = container.find('.share-list');
    $shareList.empty();
    Client.isQQ();
    let appTpl = '';
    for (let j = 0; j < APPLIST.length; j++) {
      appTpl += [
        '<li class="share-li">',
        '<div class="share-item" ' + `data-type="${APPLIST[j].type}" ` + ' data-share="' + APPLIST[j].id,
        '" data-spm-click="gostr=/aliyun;locaid=' + APPLIST[j].id + 'Button">',
        '<span class="share-icon share-icon-' + APPLIST[j].icon + '"></span>',
        '<p class="share-name">' + APPLIST[j].name + '</p>',
        '<a href="javascript:void(0);" target="_blank" class="share-link"></a>',
        '</div>',
        '</li>',
      ].join('');
    }
    $shareList.append(appTpl);
    // 支持 复制链接
    $shareList.find('[data-share="copy"]').attr('data-clipboard-text', config.content + ' ' + config.url);
    container.addClass('active-state');
    function onClose() {
      container.removeClass('active-state');
      ShareLogic.hideMask(container);
      $shareList.empty();
    }
    container.find('.share-bar-bottom-mask').on('click', onClose);
    $shareList.find('.share-item').on('click', function(event, action) {
      if (action == 'copy') {
        return;
      }
      const shareId = $(this).data('share');
      const shareType = $(this).data('type');
      if (ShareLogic[`${shareId}Share`]) {
        ShareLogic.track(shareType);
        ShareLogic[`${shareId}Share`](container, config, onClose);
      }
    });
  }
  static wxShare(container, config) {
    container.find('.share-bar-bottom-mask').show();
    if (window.wx) {
      const callback = () => {
        ShareLogic.track('A');
      };
      const meta = {
        title: config.title, // 分享标题
        desc: config.content, // 分享描述
        link: config.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: config.img, // 分享图标
        success: callback,
      };
      window.wx.onMenuShareTimeline(meta);
      window.wx.onMenuShareAppMessage(meta);
      window.wx.onMenuShareQQ(meta);
      window.wx.onMenuShareQZone(meta);
      window.wx.updateAppMessageShareData(meta, callback);
      window.wx.updateTimelineShareData(meta, callback);
    }
  }
  static weiboShare(container, config) {
    location.href =
      WEIBO_SHARE_API +
      '?url=' +
      encodeURIComponent(config.url) +
      '&title=' +
      encodeURIComponent(config.content + config.url) +
      '&content=gb2312&pic=' +
      encodeURIComponent(config.img);
  }
  static copyShare(container, config, onClose) {
    const target = container.find('[data-share="copy"]').eq(0);
    const clipboard = new Clipboard(target.get(0));
    const dom = `
    <div class="copy-container">
      <p class="copy-confirm-text">链接复制成功，快去分享吧</p>
      <p class="copy-confirm">确定</p>
    </div>
    `;
    const $dom = $(dom);
    $dom.find('.copy-confirm').on('click', onClose);
    clipboard.on('success', () => {
      container
        .find('.share-container')
        .empty()
        .append($dom);
      setTimeout(() => {
        onClose();
      }, 1500);
      clipboard.destroy();
    });
    target.trigger('click', 'copy');
  }
  static qqShare(container, config) {
    try {
      //分享到qq的参数必须用base64处理
      location.href = parseUrl(QQ_SHARE_API, {
        share_id: '101289959', // 阿里云在qq互联的APPID
        title: base64.encode(config.title),
        thirdAppDisplayName: base64.encode('阿里云'),
        url: base64.encode(config.url),
      });
    } catch (e) {
      alert('此平台暂不支持分享到qq');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/share/logic.js